<template>
    <div>
        <CustomTable
            :items.sync="componentItems"
            :fields="componentFields"
            :resizable="resizable"
        >
            <template
                v-for="field in componentListFieldsActive"
                v-slot:[field]="{ item, index }"
            >
                <slot :name="field" v-bind="{ item, index }"></slot>
            </template>
            <template #over-table>
                <slot name="over-table"></slot>
            </template>
            <template #details="{ index, item }">
                <slot name="details" v-bind="{ item, index }"></slot>
            </template>

            <template #_options="{ index }">
                <slot name="_options" v-bind="{ index }">
                    <div class="table-options">
                        

                        <CButton
                            color="success"
                            variant="outline"
                            square
                            size="sm"
                            @click="toggleDetails(index)" v-if="showButtonToggleDetails"
                        >
                            <CIcon
                                class="icon"
                                :content="
                                    $options
                                        .icons
                                        .cilPencil
                                "
                            />
                        </CButton>

                        <ButtonTrash @click="removeItem(index)" class="ml-2" />
                    </div>
                </slot>
            </template>
            <template #no-items-view>
                <div class="block-no-items section">
                    <h2 class="section__title text-no-items">
                        {{ $t(noItemsViewText) }}
                    </h2>
                    <ButtonAdd
                        @click="addItem()"
                        v-if="componentItems.length == 0"
                    />
                </div>
            </template>
            <template #under-table>
                <ButtonAdd
                    @click="addItem()"
                    v-if="componentItems.length > 0"
                />
            </template>
        </CustomTable>
    </div>
</template>

<script>
/**Components */
import ButtonAdd from "~/components/ButtonAdd.vue";
import ButtonTrash from "~/components/ButtonTrash.vue";
import ButtonEdit from "~/components/ButtonEdit.vue";
import CustomTable from "~/components/CustomTable";

/** Mixins */
import ComponentTable from "~/mixins/ComponentTable";
import traslateMixin from "~/mixins/traslate.js";

/** Others */
import {
    cilSave,
    cilArrowThickFromRight,
    cilSettings,
    cilPencil,
    cilTrash,
    cilPlus,
} from "@coreui/icons";
import FilterTypeOptions from "~/pages/app/config/options/filter_type";
import MappingFormatType from "~/assets/options/mapping_format_type.json";
import DateFormat from "~/assets/options/date_format.json";

const defaultReservedFieldOptions = {
    key: "_options",
    label: "options",
    sorter: false,
    filter: false,
    _style: "width:10%",
};

export default {
    name: "CCTableAddItems",
    mixins: [traslateMixin, ComponentTable],
    icons: {
        cilSave,
        cilArrowThickFromRight,
        cilSettings,
        cilPencil,
        cilTrash,
        cilPlus,
    },
    options: {
        FilterTypeOptions,
        MappingFormatType,
        DateFormat,
    },
    components: {
        CustomTable,
        ButtonAdd,
        ButtonTrash,
        ButtonEdit,
    },
    data() {
        return {
            componentItems: [],
            componentFields: [],
            componentLoading: false,
        };
    },
    props: {
        items: {
            type: Array,
            default: () => {
                return [];
            },
        },
        fields: {
            default: () => {
                return [];
            },
        },
        loading: {
            default: false,
        },
        resizable: {
            default: false,
        },

        noItemsViewText: {
            type: String,
            default: "Add item",
        },

        showButtonToggleDetails: {
            type: Boolean,
            default: false,
        },

        normalizeItems: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        items: {
            async handler(newValue) {
                if (this.normalizeItems) {
                    const normalizedItems = this.normalizeTableItems(newValue);
                    if(JSON.stringify(normalizedItems) !== JSON.stringify(this.componentItems)) {
                        this.componentItems = normalizedItems;
                    }
                } else {
                    this.componentItems = newValue;
                }
            },
            deep: true,
        },
        fields(newValue) {
            this.componentFields = newValue;
            this.addReservedFieldsIfNotExist();
        },
        loading(newValue) {
            this.componentLoading = newValue;
        },
        componentLoading(newValue) {
            this.$emit("update:loading", newValue);
        },
    },
    methods: {
        addReservedFieldsIfNotExist() {
            if (
                this.componentFields.findIndex(
                    (field) => field.key == "_options"
                ) == -1
            ) {
                this.componentFields.push(defaultReservedFieldOptions);
            }
        },

        toggleDetails(index) {
            this.componentItems[index]._toggled = !this.componentItems[index]._toggled;
        },

        normalizeTableItems(items) {
            return items.map(item => {
                for (const field of this.componentFields) {
                    if(
                        !Object.hasOwnProperty.call(item, field.key) 
                        && Object.hasOwnProperty.call(field, "_defaultValue") 
                    ) {
                        item = {
                            ...item,
                            [field.key]: field._defaultValue,
                        };
                    }
                }
                return item;
            });
        },
    },
    mounted() {
        this.componentFields = this.fields;

        if (this.items.length > 0) {
            if (this.normalizeItems) {
                this.componentItems = this.normalizeTableItems(this.items);
            } else {
                this.componentItems = this.items;
            }
        }

        this.addReservedFieldsIfNotExist();
    },
};
</script>

<style></style>
